export const isObjectEmpty = (object) =>
  Object.values(object).some((el) => el === undefined || el === null || el === "");
export const isValueEmpty = (value) =>
  value === undefined || value === null || value === "" || value === "null" || value === ", "
    ? "-"
    : value;
